module.exports = __webpack_public_path__ + "resources/icon_50_left_arrow_small.3f579fe0ac5b2c40.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-manage/strategy-lib-dialog/img/icon_50_left_arrow_small.png
// module id = 604
// module chunks = 0 1 2 3